<template>
  <div class="login" ref="myHeight">
    <!-- <img src="../assets/背景.png" alt=""> -->
    <div class="myInput">
      <h5 class="title">模 拟 图 系 统 软 件 V 1.0</h5>
      <div class="input">
        <el-input placeholder="账号" v-model="account" clearable @input="accountChange"></el-input>
      </div>
      <div class="input">
        <el-input placeholder="密码" v-model="passWord" show-password clearable @input="passwordChange"></el-input>
      </div>
      <!-- <div class="check">
         <el-checkbox v-model="checked" @change="changeCheck">记住密码</el-checkbox>
      </div> -->
      <div class="prompt" >
        <span>{{tip}}</span>   
      </div>
      <div class="btn">
        <el-button type="primary" round @click="doLogin">登录</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    data () {
      return {
        account:"",
        passWord:"",
        clientHeight:'',
        checked:false,
        tip:''
     }
   },
    computed:{
    },
    components:{
    },
    watch: {
      // 如果 `clientHeight` 发生改变，这个函数就会运行
      clientHeight: function () {
        this.changeFixed(this.clientHeight)
      },
    },
    mounted(){
      // 获取浏览器可视区域高度
      this.clientHeight =   `${document.documentElement.clientHeight}`         
      window.onresize = function temp() {
        this.clientHeight = `${document.documentElement.clientHeight}`;
      };
      if(JSON.parse(localStorage.getItem('user'))){
        var user=JSON.parse(localStorage.getItem('user'))
        this.account=user.account,
        this.passWord=user.password,
        this.checked=true
      }else{
        this.checked=false
      }  
    },
    methods:{
      doLogin(){
        if(!this.account){
           this.tip='请输入账号';
           return
        }else if(!this.passWord){
          this.tip='请输入密码';
          return
        }else{
          this.tip=''
          var params={
            account:this.account,
            password:this.$md5(this.passWord)
          }
           this.$api.dologin(params,res=>{
             if(res.errCode==0){
              //  //console.log(res.token,'tokentoken')
               localStorage.setItem('token', res.token);
               sessionStorage.setItem('userinfo',JSON.stringify(res.data[0]))
              this.$router.push({name:'mapList'})
             }else{
               this.tip='您输入的账号密码有误！'
             }

           })

        }
      },
      changeFixed(clientHeight){                        //动态修改样式
        // //console.log(clientHeight);
        this.$refs.myHeight.style.height = clientHeight+'px';
      },
      changeCheck(){
        if(!this.checked){
          localStorage.removeItem("user")
        }
      },
      accountChange(){
        if(!this.account){
          this.tip="请输入账号"
        }else{
          this.tip=''
        }
      },
      passwordChange(){
        if(!this.passWord){
          this.tip="请输入密码"
        }else{
          this.tip=''
        }
      },
    }
}

</script>
<style scoped>
.login{
  background-image: url("../assets/背景.jpg") ;
  background-size:cover ;
  background-repeat: no-repeat;
}
.myInput{
  width:230px;
  height: 260px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0px 0px 5px #ccc;
  float: right;
  margin-right: 10%;
  margin-top: 12%;
  padding: 40px;
}
.input /deep/ .el-input__inner{
  border: none;
  border-bottom: 1px solid #DCDFE6;
  border-radius: 0;
  
}
.input,.check{
  margin-top: 15px;
}
.check{
    text-align: left;
    padding-left: 10px;
}
.check /deep/ .el-checkbox{
  color: #999;
  font-size: 12px;
}
.btn{
  margin-top: 10px;
}
.btn /deep/ .el-button{
  width: 100%;
}
.title{
  height:30px;
  text-align: center;
  margin: 0;
  font-size: 16px;
}
.prompt{
  color: red;
  font-size: 12px;
  margin-top: 10px;
  height: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/login.vue